import {
  SyncOutlined,
  CheckCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { useAppTranslation } from "~/hooks/useAppTranslation";
import * as APITypes from "~/API";

export const ReservationStatusTag = ({
  status,
}: {
  status?: APITypes.AmenityReservationStatus | null;
}) => {
  const { t } = useAppTranslation();
  let color = "grey";
  let icon = <SyncOutlined />;
  let statusText = t("None");

  switch (status) {
    case APITypes.AmenityReservationStatus.Pending:
      color = "yellow";
      icon = <ClockCircleOutlined />;
      statusText = t("Pending");
      break;
    case APITypes.AmenityReservationStatus.Approved:
      color = "green";
      icon = <CheckCircleOutlined />;
      statusText = t("Approved");
      break;
    case APITypes.AmenityReservationStatus.Rejected:
      color = "red";
      icon = <StopOutlined />;
      statusText = t("Rejected");
      break;
    case APITypes.AmenityReservationStatus.Canceled:
      color = "orange";
      icon = <CloseCircleOutlined />;
      statusText = t("Canceled");
      break;
  }

  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
